import React from 'react';
import { useShutdownAccesses } from '../../../../../shared/lib/hooks/useShutdownAccesses';
import ListCellContent from '../../../../../shared/ui/ListCellContent/ListCellContent';
import { shutdownResponsibleQuery } from '../../../../../shared/api/queries';
import Item from './components/Item/Item';
import DeleteEntity from './components/DeleteEntity/DeleteEntity';
import AddEntity from './components/AddEntity/AddEntity';
import styles from './Content.module.scss';

const { useShutdownResponsible } = shutdownResponsibleQuery;

const getItems = (items) =>
  items?.length ? items : [{ id: 0, name: 'Не указаны' }];

const ActiveExecutors = ({ shutdown, rowExpanded = false }) => {
  const itemsAmount = shutdown.executors?.length || 0;
  const companyId = shutdown?.serviceCompany?.id;

  const { data } = useShutdownResponsible([companyId], {
    staleTime: Infinity,
    enabled: Boolean(rowExpanded),
  });

  const showAddBtn = rowExpanded && itemsAmount < data?.length;

  return (
    <>
      <ListCellContent
        className={styles.root}
        items={getItems(shutdown.executors)}
        renderItem={({ item, parentWidth }) =>
          Boolean(itemsAmount) ? (
            <DeleteEntity
              item={item}
              parentWidth={parentWidth}
              shutdown={shutdown}
            />
          ) : (
            <Item
              item={item}
              parentWidth={parentWidth}
            />
          )
        }
      />
      {showAddBtn && <AddEntity shutdown={shutdown} />}
    </>
  );
};

const Content = ({ shutdown, rowExpanded }) => {
  const { canChange } = useShutdownAccesses();

  if (!canChange) {
    return (
      <ListCellContent
        className={styles.root}
        items={getItems(shutdown.initiators)}
        renderItem={({ item, parentWidth }) => (
          <Item
            item={item}
            parentWidth={parentWidth}
          />
        )}
      />
    );
  }

  return (
    <ActiveExecutors
      shutdown={shutdown}
      rowExpanded={rowExpanded}
    />
  );
};

export default Content;
